export const DROPDOWN_ALL_TEXT = 'common.All';
export const DROPDOWN_SELECT_ALL_TEXT = 'common.SelectAll';
export const DROPDOWN_ALL_VALUE = '';
